import { heroImages, matchStoryImages } from '#shared/models/images.ts'
import type { CMSBlog } from '#shared/types/cmsLayout.ts'

export async function useRandomMatchStories() {
  const localeStore = useLocaleStore()
  const route = useRoute()

  const { data: stories } = await useAsyncData<{
    data: CMSBlog<keyof typeof matchStoryImages>[]
  }>(
    `match-stories-${route.path}`,
    () =>
      $fetch('/api/website-page/fetch-random', {
        query: {
          type: 'match-story-pages',
          slug: route.name
        }
      }),
    { server: false }
  )

  return computed(() =>
    (stories.value?.data ?? []).map((story) => ({
      to: `/verhalen/${story.slug}`,
      title: story.title[localeStore.locale],
      description: story.description[localeStore.locale],
      date: story.datePublished,
      image:
        story.image in matchStoryImages
          ? matchStoryImages[story.image]
          : heroImages['vincent-stopt-eten-in-bakje']
    }))
  )
}
